import React, { useState } from 'react';
import { useHistory } from 'react-router';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import LoginEmail from 'screens/components/LoginEmail';
import * as loginService from 'services/loginService';

const LoginEmailContainer = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();

  const handleSubmit = async (email: string, password: string) => {
    setLoading(true);
    try {
      const response = await loginService.handleLoginEmail(email, password);
      history.push(`/corporate/?token=${response.accessToken}`);
    } catch (error) {
      const status = error.status;

      if (status === 409 || status === 401) {
        toast.add({ type: 'danger', message: t('loginEmail.accountInactivated') });
        return;
      }
      toast.add({ type: 'danger', message: t('loginEmail.invalidPassword') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginEmail loading={isLoading} onLogin={(email: string, password: string) => handleSubmit(email, password)} />
  );
};

export default LoginEmailContainer;
